const ArrayTableBody = ({fields, data, children}) => {

    const getValue = (field, row) => {
        field = field.split('.')
        var val = row
        field.forEach( (nested) => {
            if(val){
                val = val[nested]
            }
        })
        return val

    }

    const rows = data.map( (row) => {
        const cells = Object.keys(fields).map( (field) => {
            if(fields[field].formatter){ //check if a formatter is send
                return <td className={fields[field].className}>{fields[field].formatter(getValue(field, row), row, row.id)}</td>
            }
            return <td className={fields[field].className}>{getValue(field, row)}</td>
        })
        return <tr>
            {cells}
        </tr> 
    })

    return <tbody>
        {rows}
        {children}
    </tbody>
}
export default ArrayTableBody